(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class LoadMoreProducts extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-load-more-button]');
      this.label = this.querySelector('[data-load-more-label]');
      this.spinner = this.querySelector('.loading__spinner');
      this.status = this.querySelector('[data-load-more-status]');
      this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');

      if (!this.button || !this.grid) return;

      this.handleClick = this.handleClick.bind(this);
      this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      this.abortController?.abort();
    }

    async handleClick(event) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      if (this.loading || this.complete) {
        event.preventDefault();
        return;
      }

      if (!window.fetch || !window.DOMParser) return;

      event.preventDefault();
      this.setLoading(true);
      this.setStatus(this.dataset.loadingMessage);
      this.abortController = new AbortController();

      try {
        const requestUrl = new URL(this.button.href, window.location.href);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);

        const response = await fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.abortController.signal,
        });

        if (!response.ok) throw new Error(`Unable to load collection page: ${response.status}`);

        const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const responseGrid = responseDocument.querySelector('#ProductGridContainer #product-grid');

        if (!responseGrid || !this.isConnected || !this.grid.isConnected) {
          throw new Error('Unable to find the next collection product grid.');
        }

        const existingProductIds = new Set(
          Array.from(this.grid.children, (item) => item.dataset.productId).filter(Boolean)
        );
        const responseItems = Array.from(responseGrid.children);
        let addedCount = 0;

        responseItems.forEach((item) => {
          const productId = item.dataset.productId;
          if (productId && existingProductIds.has(productId)) return;

          item.querySelectorAll('link[rel="stylesheet"]').forEach((stylesheet) => stylesheet.remove());
          item.querySelectorAll('img').forEach((image) => {
            image.loading = 'lazy';
            image.removeAttribute('fetchpriority');
          });
          item.classList.remove('scroll-trigger--offscreen');
          item.classList.add('scroll-trigger--cancel');
          this.grid.appendChild(document.importNode(item, true));
          if (productId) existingProductIds.add(productId);
          addedCount += 1;
        });

        const nextLoader = responseDocument.querySelector('#ProductGridContainer load-more-products');
        const nextButton = nextLoader?.querySelector('[data-load-more-button]');
        const currentPage = Number(responseGrid.dataset.currentPage || 1);
        const totalItems = Number(responseGrid.dataset.totalItems || this.grid.children.length);
        const shownItems = Math.min(this.grid.children.length, totalItems);
        const loadedMessage = responseGrid.dataset.productCountMessage;

        this.setStatus(loadedMessage);

        if (nextButton) {
          this.button.href = nextButton.getAttribute('href');
          this.label.textContent = this.dataset.loadLabel;
        } else {
          this.complete = true;
          this.button.removeAttribute('href');
          this.button.setAttribute('aria-disabled', 'true');
          this.button.classList.add('is-complete');
          this.label.textContent = this.dataset.completeLabel;
        }

        this.dispatchEvent(
          new CustomEvent('collection:products-loaded', {
            bubbles: true,
            detail: {
              sectionId: this.dataset.sectionId,
              currentPage,
              addedCount,
              shownItems,
              totalItems,
            },
          })
        );
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.label.textContent = this.dataset.loadLabel;
        this.setStatus(this.dataset.errorMessage, true);
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      this.loading = isLoading;
      this.classList.toggle('is-loading', isLoading);
      this.button.classList.toggle('loading', isLoading);
      this.spinner?.classList.toggle('hidden', !isLoading);
      this.toggleAttribute('aria-busy', isLoading);
      this.grid.toggleAttribute('aria-busy', isLoading);

      if (isLoading || this.complete) {
        this.button.setAttribute('aria-disabled', 'true');
      } else {
        this.button.removeAttribute('aria-disabled');
      }
    }

    setStatus(message, isError = false) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.toggle('visually-hidden', !isError);
    }
  }

  if (!customElements.get('load-more-products')) {
    customElements.define('load-more-products', LoadMoreProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
